import {axios as http} from "@/plugins/http"

export default class Api {
    static statisticPosts(ids, typeId) {
        return http.post("/api/v1/statistic/posts", {
            post_id: ids,
            type_id: typeId,
        }).then((resp) => {
            return resp.data["items"]
        })
    }

    static statisticPostsChain(ids, typeId) {
        return http.post("/api/v1/statistic/posts-chain", {
            post_id: ids,
            type_id: typeId,
        }).then((resp) => {
            return resp.data["items"]
        })
    }

    static statisticPostsPointRating(ids, typeId) {
        return http.post("/api/v1/statistic/point/rating", {
            post_id: ids,
            type_id: typeId,
        }).then((resp) => {
            return resp.data["items"]
        })
    }

    static statisticPostsPointChainRating(ids, typeId) {
        return http.post("/api/v1/statistic/point/chain/rating", {
            post_id: ids,
            type_id: typeId,
        }).then((resp) => {
            return resp.data["items"]
        })
    }

    static statisticRating(ids, typeId) {
        return http.post("/api/v1/post/rating", {
            post_ids: ids,
            type_id: typeId,
        }).then((resp) => {
            return resp.data["items"]
        })
    }
}
